const SvgDevice = (props) => (
  <svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
    <g fill="none" fillRule="nonzero">
      <path d="M-1-1h18v18H-1z" />
      <path
        d="M12 0a1.6 1.6 0 0 1 1.6 1.6v8a1.6 1.6 0 0 1-1.6 1.6H8.444v2.489H9.6a.8.8 0 0 1 .8.8H16v.711h-5.6a.8.8 0 0 1-.8.8H6.4a.8.8 0 0 1-.8-.8H0v-.711h5.6a.8.8 0 0 1 .8-.8h1.156V11.2H4a1.6 1.6 0 0 1-1.6-1.6v-8A1.6 1.6 0 0 1 4 0h8zM4.111.711a1 1 0 0 0-1 1V9.49a1 1 0 0 0 1 1h7.778a1 1 0 0 0 1-1V1.71a1 1 0 0 0-1-1H4.11z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default SvgDevice
